/* eslint-disable prettier/prettier */
import React from 'react';
import { Activity, WeekRange } from '../../types/schedule.types';
import icon from '../../assets/Schedule/Vector.png';
import {
	getWeekDates,
	getDayLabel,
	isToday,
	toDateKey,
} from '../../utils/dateUtils';
import DayColumn from './DayColumn';
import styles from '../../styles/Schedule/WeekGrid.module.css';

interface WeekGridProps {
	selectedWeek: WeekRange;
	activitiesByDate: Map<string, Activity[]>;
	loading: boolean;
	onActivityClick?: (activity: Activity) => void;
}

const WeekGrid: React.FC<WeekGridProps> = ({
	selectedWeek,
	activitiesByDate,
	loading,
	onActivityClick,
}) => {
	const weekDates = getWeekDates(selectedWeek);

	const isWeekEmpty = weekDates.every(date => {
		const key = toDateKey(date);
		const activities = activitiesByDate.get(key) ?? [];
		return activities.length === 0;
	});

	if (loading) {
		return (
			<div className={styles.loading}>
				<div className={styles.spinner} />
				<span>Loading schedule…</span>
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.grid}>
				{weekDates.map(date => {
					const key = toDateKey(date);
					const activities = activitiesByDate.get(key) ?? [];
					const dayLabel = getDayLabel(date);

					return (
						<DayColumn
							key={key}
							dayLabel={dayLabel}
							date={date}
							activities={activities}
							isToday={isToday(date)}
							onActivityClick={onActivityClick}
						/>
					);
				})}
			</div>

			{isWeekEmpty && (
				<div className={styles.emptyOverlay}>
					<div className={styles.emptyState}>
						<div className={styles.emptyIcon}>
							<img className={styles.icon} src={icon} alt="" />
						</div>
						<p className={styles.emptyText}>
							No activities for this week
						</p>
					</div>
				</div>
			)}
		</div>
	);
};

export default WeekGrid;
